export const pubAndSerApi = {
  ADD_WHIST_LIST: '/api/fair/visitor/wishlist',
  GET_PUBLIC_PRODUCT_AND_SERVICE: '/api/fair/products',
  ADD_NON_VISITOR_INFORMATION: '/api/fair/visitor/wishlist/non-visitor',
  LOGIN_VISITOR_COMMENTS: '/api/fair/visitor/wishlist/comment',
};
